import React from 'react'
import { ReactNode } from 'react'

function PublicHeaderFeaturesIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="29"
      height="25"
      viewBox="0 0 29 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.83911 3.83917C2.83911 3.28689 3.28683 2.83917 3.83911 2.83917H25.1389C25.6912 2.83917 26.1389 3.28689 26.1389 3.83917V14.3415C26.1389 14.8938 25.6912 15.3415 25.1389 15.3415H3.83911C3.28683 15.3415 2.83911 14.8938 2.83911 14.3415V3.83917Z"
        fill="currentColor"
        className="text-text-link"
      />
      <path
        d="M26.7141 0H2.26391C1.01559 0 0 1.01559 0 2.26391V18.1898C0 19.4381 1.01559 20.4537 2.26391 20.4537H11.3657V23.868H10.2268C9.91422 23.868 9.66083 24.1214 9.66083 24.434C9.66083 24.7466 9.91422 25 10.2268 25H18.7511C19.0637 25 19.3171 24.7466 19.3171 24.434C19.3171 24.1214 19.0637 23.868 18.7511 23.868H17.6122V20.4537H26.7141C27.9624 20.4537 28.978 19.4381 28.978 18.1898V2.26391C28.978 1.01559 27.9624 0 26.7141 0V0ZM16.4803 23.868H12.4977V20.4537H16.4803V23.868ZM27.8461 18.1898C27.8461 18.814 27.3383 19.3218 26.7141 19.3218C25.5298 19.3218 3.11502 19.3218 2.26391 19.3218C1.63975 19.3218 1.13195 18.814 1.13195 18.1898V2.26391C1.13195 1.63975 1.63975 1.13195 2.26391 1.13195H26.7141C27.3383 1.13195 27.8461 1.63975 27.8461 2.26391V18.1898Z"
        fill="currentColor"
        className="text-text-primary"
      />
      <path
        d="M15.0573 17.0486H13.9207C13.6081 17.0486 13.3547 17.302 13.3547 17.6146C13.3547 17.9272 13.6081 18.1805 13.9207 18.1805H15.0573C15.3699 18.1805 15.6233 17.9272 15.6233 17.6146C15.6233 17.302 15.3699 17.0486 15.0573 17.0486Z"
        fill="currentColor"
        className="text-text-primary"
      />
      <path
        d="M16.7621 10.7928H17.3304C17.643 10.7928 17.8964 10.5394 17.8964 10.2268C17.8964 9.91422 17.643 9.66083 17.3304 9.66083H16.7621C16.4496 9.66083 16.1962 9.91422 16.1962 10.2268C16.1962 10.5394 16.4496 10.7928 16.7621 10.7928Z"
        fill="currentColor"
        className="text-text-on"
      />
      <path
        d="M16.7621 8.51971H17.3304C17.643 8.51971 17.8964 8.26632 17.8964 7.95373C17.8964 7.64114 17.643 7.38776 17.3304 7.38776H16.7621C16.4496 7.38776 16.1962 7.64114 16.1962 7.95373C16.1962 8.26627 16.4496 8.51971 16.7621 8.51971Z"
        fill="currentColor"
        className="text-text-on"
      />
      <path
        d="M12.2159 9.66083H11.6476C11.335 9.66083 11.0816 9.91422 11.0816 10.2268C11.0816 10.5394 11.335 10.7928 11.6476 10.7928H12.2159C12.5285 10.7928 12.7819 10.5394 12.7819 10.2268C12.7819 9.91427 12.5285 9.66083 12.2159 9.66083Z"
        fill="currentColor"
        className="text-text-on"
      />
      <path
        d="M12.2159 7.38776H11.6476C11.335 7.38776 11.0816 7.64114 11.0816 7.95373C11.0816 8.26632 11.335 8.51971 11.6476 8.51971H12.2159C12.5285 8.51971 12.7819 8.26632 12.7819 7.95373C12.7819 7.64109 12.5285 7.38776 12.2159 7.38776Z"
        fill="currentColor"
        className="text-text-on"
      />
      <path
        d="M19.6036 4.54626H16.1869C15.5112 4.54626 14.9042 4.84419 14.489 5.31514C14.0739 4.84419 13.4668 4.54626 12.7911 4.54626H9.37445C9.06186 4.54626 8.80847 4.79965 8.80847 5.11224V13.0683C8.80847 13.3809 9.06186 13.6343 9.37445 13.6343H19.6036C19.9162 13.6343 20.1696 13.3809 20.1696 13.0683V5.11224C20.1696 4.79965 19.9162 4.54626 19.6036 4.54626ZM13.923 12.5023H9.94043V5.67822H12.7911C13.4152 5.67822 13.923 6.18601 13.923 6.81017V12.5023ZM19.0376 12.5023H15.055V6.81017C15.055 6.18601 15.5628 5.67822 16.1869 5.67822H19.0376V12.5023Z"
        fill="currentColor"
        className="text-text-on"
      />
    </svg>
  )
}

export default PublicHeaderFeaturesIcon
